export class StockFixedIncome {
  id: string;
  positionDate: string;
  positions: StockFixedIncomePosition[];
  committedPositions: StockFixedIncomeCommittedPosition[];
  termPositions: StockFixedIncomeTermPosition[];
}

export class StockFixedIncomePosition {
  operationCode: string;
  purchaseDate: string;
  issuerName: string;
  serie: string;
  code: string;
  issueCode: string;
  selicCode: string;
  issueDate: string;
  dueDate: string;
  quantity: number;
  pu: number;
  purchaseValue: number;
  netValue: number;
}

export class StockFixedIncomeCommittedPosition {
  operationCode: string;
  purchaseDate: string;
  securityName: string;
  originalDate: Date;
  dueDate: Date;
  securities: StockFixedIncomeCommitedPositionSecurity[];
  issuerName: string;
  quantity: number;
  pu: number;
  purchaseValue: number;
}

export class StockFixedIncomeCommitedPositionSecurity {
  issueDate: Date;
  dueDate: Date;
}

export class StockFixedIncomeTermPosition {
  operationCode: string;
  purchaseDate: string;
  issuerName: string;
  securityName: string;
  series: string;
  issueDate: Date;
  dueDate: Date;
  quantity: number;
  pu: number;
  purchaseValue: number;
  netValue: number;
}
